import AssetSummaryTable from 'src/components/AssetSummaryTable';

import ReviewDifference from 'src/components/ReviewDifference';
import ReviewDifferenceTable from 'src/components/ReviewDifferenceTable';
import ReviewSectionAccordion from 'src/components/ReviewSectionAccordion';
import LeasedAssetSummary from 'src/components/LeasedAssetSummary';

import {
  createBusinessLocationValues,
  createBusinessValues,
  createContactInfoValues,
  createNatureOfBusinessValues,
} from 'src/util/createReviewValues';

const SubFillingDetailsSections = ({
  businessInfo,
  businessContacts,
  updatedInfo,
  updatedBusinessContacts,
  assetsAdded,
  assetsChanged,
  assetsRetired,
  priorAssets,
  total,
  leasedAssets,
}) => {
  return (
    <>
      <ReviewSectionAccordion title={`Business Name & Billing Address`}>
        <ReviewDifference values={createBusinessValues(businessInfo, updatedInfo)} />
      </ReviewSectionAccordion>
      <ReviewSectionAccordion title={`Business Location`}>
        <ReviewDifference values={createBusinessLocationValues(businessInfo, updatedInfo)} />
      </ReviewSectionAccordion>
      <ReviewSectionAccordion title={`Contact Information`}>
        <ReviewDifferenceTable
          headers={['Description', 'Name', 'Address']}
          values={createContactInfoValues(businessContacts, updatedBusinessContacts)}
        />
      </ReviewSectionAccordion>
      <ReviewSectionAccordion title={`Nature of Business / Ownership Type`}>
        <ReviewDifference values={createNatureOfBusinessValues(businessInfo, updatedInfo)} />
      </ReviewSectionAccordion>
      <ReviewSectionAccordion title={`Asset Summary: (Schedule B)`}>
        <AssetSummaryTable
          assetsAdded={assetsAdded}
          assetsChanged={assetsChanged}
          assetsRetired={assetsRetired}
          priorAssets={priorAssets}
          total={total}
        />
      </ReviewSectionAccordion>

      <ReviewSectionAccordion title={`Leased Asset Summary: (Schedule D)`}>
        <LeasedAssetSummary assets={leasedAssets} />
      </ReviewSectionAccordion>
    </>
  );
};

export default SubFillingDetailsSections;
